





import marked from 'marked'
import { Component, Vue } from 'vue-property-decorator'
import { PropType } from 'vue'
import { TrelloCard } from '../../TrelloClient'

@Component({
    props: {
        card: Object as PropType<TrelloCard>,
    },
})
export default class extends Vue {

    get markdownDescription() {
        let cleanDesc = (this as any).card.desc.replace(/#(\w)/g, '# $1')
        return marked(cleanDesc)
    }

}

